import React from 'react';
import { get } from 'lodash';
import cx from 'classnames';
import FormattedMessage from 'components/FormattedMessage/FormattedMessage';
import { PriceType } from '@rome/response/transact/PriceType';
import styles from './PriceWidget.css';
export const Applied = (props) => {
    const { cartItem } = props;
    const { pricingInfo, cardPricingDetails } = cartItem;
    if (!cardPricingDetails || !pricingInfo) {
        return null;
    }
    const { coinApplied } = pricingInfo;
    const prices = get(cardPricingDetails, 'prices', []);
    const coinPrice = prices.find(price => price.priceType === PriceType.COIN_PRICE);
    const multiCurrencyPrice = get(coinPrice, 'multiCurrencyPrice');
    if (coinApplied) {
        return (<PlusPrice plusPriceInfo={multiCurrencyPrice} plusPriceClass={styles['plus-price-applied']} imageSize={16}/>);
    }
    return null;
};
export const Applicable = (props) => {
    const { cartItem } = props;
    const { pricingInfo, cardPricingDetails } = cartItem;
    if (!cardPricingDetails || !pricingInfo) {
        return null;
    }
    const { coinApplied, coinApplicable } = pricingInfo;
    const coinPrice = get(cardPricingDetails, 'coinPrice');
    if (!coinApplied && coinApplicable) {
        return <PlusPrice plusPriceInfo={coinPrice} plusPriceClass={styles['plus-price']}/>;
    }
    return null;
};
export default function PlusPrice(props) {
    const { plusPriceInfo, plusPriceClass, imageSize = 12 } = props;
    if (!plusPriceInfo) {
        return null;
    }
    const { data } = plusPriceInfo;
    return (<FormattedMessage data={data} containerClass={cx(styles['plus-price'], plusPriceClass)} imageSize={imageSize}/>);
}
